export { default } from "./ReportContentFormHeading";
